import {css} from "@emotion/css";
import React from "react";
import {convertCurrencyFormatPositiveNegative} from "./numberConvertor";

export const preparePositiveNegativeNumberCell = (number) => {
    const _number = convertCurrencyFormatPositiveNegative(number)

    return <div className={"d-flex flex-shrink-1 alignItemsCenter w-100 justifyContentCenter"}>
        {number === 0 ? 0 : parseFloat(_number) >= 0 ?
            <span className={css`direction: ltr !important;`}>{_number}</span> :
            <span className={`bg_deActive_state ${css`direction: ltr !important;`}`}>{_number}</span>
        } </div>
}

export const prepareStatusCell = (
    status,
    activeStateTitle = "فعال",
    deActiveStateTitle = "غیر فعال") => {
    return <div className={"d-flex flex-shrink-1 alignItemsCenter w-100 justifyContentCenter"}>
        {status ? <span className="bg_active_state">{activeStateTitle}</span> :
            <span className="bg_deActive_state">{deActiveStateTitle}</span>
        }
    </div>
}